<template lang="pug">
    v-tooltip(bottom='')
        template(v-slot:activator='{ on }')
            v-btn(color='primary' icon v-on='on' @click='imprimir_modal()' dialog=true)
                v-icon(small) fas fa-print
        span Imprimir
</template>
<script>
import {mapState} from 'vuex'
export default {
    data:()=>({
        dialog:false,

    }),
    methods:{
         imprimir_modal(){
            let nueva_ventana=window.open('scrollbars=0','popimpr')
            let domClone = document.getElementById(this.nombre_de_impresion).cloneNode(true)
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }
            nueva_ventana.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    ${stylesHtml}
                    <style>
                        *{
                            font-family: 'Roboto';
                        }
                        .mt-5{
                            margin-top: 20px;
                        }
                    
                    </style>
                </head>

                </html>`);
            nueva_ventana.document.body.HTML = "";
            console.log(domClone)
            nueva_ventana.document.body.appendChild(domClone)
            setTimeout(()=>nueva_ventana.print(), 1000)
            
            //nueva_ventana.close()
        },
    },
    props:{
        nombre_de_impresion:String
    },
     ...mapState({
      Customers: state=>state.Customers.data,
    }),
}
</script>